import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../general-catalog-select.service';

export interface TypeAmountSelectOption {
  value: string;
  label: string;
  code?: string;
}

/** Catálogo `amount_types` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeAmountSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeAmountSelectOption[]> {
    return this.generalCatalogSelect.getListOptionsByPrefix('amount_types').pipe(
      map((options) =>
        options.map((o) => ({
          value: o.value,
          label: o.label,
          code: o.code || '',
        })),
      ),
    );
  }
}
